import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../MissionAndVission/MissioonSideCards/MissioonSideCards.css";
import "../../TravelArrangements/TravelArrangementsSideCards/TravelArrangementsSideCards.css";

const UniversitySideCards = () => {
  return (
    <>
      <div className="container mt-md-5">
        <div className="row">
          <div className="safetyCardBox mb-5 pb-lg-3">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
              <h1 className="headings mt-3 uni-heading  ps-2 ps-md-0">
                <span>University </span> Faculty{" "}
                <span className="text-dark" style={{ fontWeight: "bold" }}>
                  &{" "}
                </span>
                Staff
              </h1>
              <p className="missionP-one px-2 px-md-0">
                Blueberry Travel has been a trusted partner to top universities
                for over 30 years, providing customized travel programs for
                faculty and staff. Whether it’s managing executive travel for
                deans or organizing large group trips, our solutions cater to
                all university levels, funding sources, and travel regulations.
                We work with you to design personalized programs that improve
                travel efficiency while ensuring compliance with federal, state,
                and institutional guidelines.
              </p>
              <p className="missionP-two px-2 px-md-0">
                Furthermore, we take care of every detail in your travel
                program—from hotel and flight bookings to unused ticket
                management. Our personalized approach ensures each traveler
                receives a custom itinerary while we handle logistics with
                efficiency and precision. Even if you’re coordinating
                international conferences or simplifying small research trips,
                Blueberry Travel offers easy travel management and
                cost-effective solutions. Contact us today to simplify your
                university’s travel program!
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/universioty1.png"
                alt=""
                className="safetyTravelimg mission-images"
                loading="lazy"
              />
            </div>
          </div>

          <div className="safetyCardBoxReverse pb-lg-3 mb-lg-5">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
              <h1 className="headings mt-3 uni-heading ps-2 ps-md-0">
                <span>Upgrade </span>Your Athletic Travel
              </h1>
              <p className="missionP-one px-2 px-md-0">
                From tournament qualifications and team changes to managing
                unexpected challenges like injuries or tight schedules, we are
                here to turn your obstacles into opportunities. Our dedicated
                team thrives in these environments, offering expert solutions
                that ensure your team travels with confidence. Whether you’re
                organizing domestic games or international tournaments, we
                handle all the logistics so that you can stay focused on the
                game.
              </p>
              <p className="missionP-two px-2 px-md-0">
                With over 30 years of experience, Blueberry Travels has built a
                strong legacy of supporting athletic teams, coaches, and staff.
                Our custom approach includes negotiating vendor contracts that
                protect your team’s interests and mitigate risks. Trust
                Blueberry Travels to deliver an unmatched, stress-free travel
                experience. Get in touch with us today to upgrade your athletic
                travel program!
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-xxl-5">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/university2.png"
                alt=""
                className="safetyTravelimg safetyTravelimg2 mission-images"
                loading="lazy"
              />
            </div>
          </div>

          <div className="safetyCardBox pb-lg-3 mb-lg-5">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-3">
              <h1 className="headings mt-3 uni-heading ps-2 ps-md-0">
                <span>Health </span>Science Centers
              </h1>
              <p className="missionP-one px-2 px-md-0">
                We specialize in managing travel for health science centers,
                hospitals, and academic institutions. With extensive experience
                in coordinating travel for faculty, staff, residents, fellows,
                and even patients, we understand the unique challenges of
                healthcare-related travel. So, we provide a customized travel
                experience, handling everything from executive travel for
                C-suite leaders to large-scale group bookings.
              </p>
              <p className="missionP-two px-2 px-md-0">
                Blueberry Travels designs flexible programs matched to your
                institution’s needs, including managing federal grants, state
                funds, and municipal regulations. We integrate a range of
                services, from easy online booking and pre-payment systems to
                ensuring compliance with regulations like the Fly America Act.
                Trust Blueberry Travels to manage your health science center’s
                travel with precision, flexibility, and full support every step
                of the way. Contact us today to optimize your travel program.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/university3.png"
                alt=""
                className="safetyTravelimg mission-images"
                loading="lazy"
              />
            </div>
          </div>
          <div className="safetyCardBoxReverse pb-lg-3 mb-lg-5">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-3">
              <h1 className="headings mt-3 uni-heading ps-2 ps-md-0">
                <span>Study </span>Abroad Journeys
              </h1>
              <p className="missionP-one px-2 px-md-0">
                Unlike other providers that group study abroad and athletics
                together, we recognize the distinct needs of these programs.
                That’s why we maintain dedicated teams for each, ensuring a
                specialized, focused approach for your academic and cultural
                adventures. From booking flights to arranging local meals and
                securing VIP access to museums, our team manages every detail to
                provide a flawless study abroad journey.
              </p>
              <p className="missionP-two px-2 px-md-0">
                Blueberry Travels goes beyond traditional travel management by
                offering personalized support and expertise that enhances the
                global learning experience. Our experienced agents are available
                around the clock to ensure smooth operations and assist with any
                challenges that may arise. With Blueberry Travels, your study
                abroad program will be a well-organized, unforgettable global
                adventure. Contact us to start planning your journey today.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-xxl-5">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/university4.png"
                alt=""
                className="safetyTravelimg safetyTravelimg2 mission-images"
                loading="lazy"
              />
            </div>
          </div>

          <div className="safetyCardBox ct-lastcard-mb pb-lg-5 mb-lg-5">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-3">
              <h1 className="headings mt-3 uni-heading ps-2 ps-md-0">
                <span>Recreational </span>Sports Teams
              </h1>
              <p className="missionP-one px-2 px-md-0">
                Coordinating travel for recreational sports groups can be
                complex, but Blueberry Travels is here to simplify the process.
                Whether it’s a flag football team, fraternity sports league, or
                any other recreational group, we specialize in taking the stress
                out of travel arrangements. Our services include coordinating
                ground transportation, securing hotel room blocks, and offering
                a user-friendly online booking system, ensuring everything goes
                smoothly.
              </p>
              <p className="missionP-two px-2 px-md-0">
                Our in-house online booking engine makes reserving everything
                easy, and our reliable after-hours support ensures support
                whenever you need it. Get started with your sports travel
                program today.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/university5.png"
                alt=""
                className="safetyTravelimg mission-images"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UniversitySideCards;
